import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dd1f514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-title-text" }, " Estatísticas ", -1))
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "streaks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_local_stats_item = _resolveComponent("local-stats-item")!
  const _component_wins_distribution_graph = _resolveComponent("wins-distribution-graph")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_q_btn, {
              onClick: _ctx.hide,
              flat: "",
              icon: "close"
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_local_stats_item, {
                    label: 'Jogos',
                    value: _ctx.localStats.amountOfGames.toString()
                  }, null, 8, ["value"]),
                  _createVNode(_component_local_stats_item, {
                    label: 'Vitórias',
                    value: _ctx.winsPercentage
                  }, null, 8, ["value"]),
                  _createVNode(_component_local_stats_item, {
                    label: 'Sequência Atual',
                    value: _ctx.localStats.currentStreak.toString()
                  }, null, 8, ["value"]),
                  _createVNode(_component_local_stats_item, {
                    label: 'Melhor Sequência',
                    value: _ctx.localStats.maxStreak.toString()
                  }, null, 8, ["value"])
                ]),
                _createVNode(_component_wins_distribution_graph, { localStats: _ctx.localStats }, null, 8, ["localStats"])
              ]),
              _: 1
            }),
            (_ctx.showShare)
              ? (_openBlock(), _createBlock(_component_q_separator, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.showShare)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "section-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      style: {backgroundColor: '#006847'},
                      onClick: _ctx.share,
                      label: "Compartilhar",
                      icon: "share"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "info",
                      onClick: _ctx.showShareInfoDialog
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}